import { IMetadataEndpoint } from '@broadleaf/admin-components/dist/types/metadata';

export function getFetchInvoicesEndpoint(): IMetadataEndpoint {
  return {
    params: {
      query: '${filter.query}',
      cq: '${filter.query_builder}',
      page: '${paging.pageNumber}',
      size: 50
    },
    mapParams: [
      {
        from: 'sort.sort',
        to: 'sort'
      }
    ],
    scope: 'ORDER',
    type: 'GET',
    uri: '/search/order-search'
  };
}

export function getSubmitInvoicesEndpoint(): IMetadataEndpoint {
  return {
    scope: 'INVOICE',
    type: 'POST',
    uri: '/order/invoices/export'
  };
}

export function getBulkInvoicesStatusChangeEndpoint(): IMetadataEndpoint {
  return {
    scope: 'INVOICE',
    type: 'POST',
    uri: '/order/invoices/status-change'
  };
}

export function getInvoicesExportEndpoint(): IMetadataEndpoint {
  return {
    scope: 'INVOICE',
    type: 'POST',
    uri: '/order-operations/invoice/exports'
  };
}

export function getInvoicesExportStatusEndpoint(
  exportId: string
): IMetadataEndpoint {
  return {
    scope: 'INVOICE',
    type: 'GET',
    uri: '/order-operations/invoice/exports/' + exportId
  };
}

export function getInvoicesExportDownloadEndpoint(
  exportId: string
): IMetadataEndpoint {
  return {
    scope: 'INVOICE',
    type: 'GET',
    uri: '/order-operations/invoice/exports/' + exportId + '/download'
  };
}

export function getApplyInvoicePaymentEndpoint(
  invoiceId: string
): IMetadataEndpoint {
  return {
    scope: 'INVOICE',
    type: 'POST',
    uri: '/order/invoices/' + invoiceId + '/payment'
  };
}

export function getApplyInvoiceSettingsEndpoint(
  invoiceId: string
): IMetadataEndpoint {
  return {
    scope: 'INVOICE',
    type: 'POST',
    uri: '/order/invoices/' + invoiceId + '/settings'
  };
}

export function getAccountEndpoint(accountId: string): IMetadataEndpoint {
  return {
    scope: 'ACCOUNT',
    type: 'GET',
    uri: `/customer/accounts/${accountId}`
  };
}

export function getCustomerEndpoint(customerId: string): IMetadataEndpoint {
  return {
    scope: 'CUSTOMER',
    type: 'GET',
    uri: `/customer/customers/${customerId}`
  };
}

export function getCustomersEndpoint(): IMetadataEndpoint {
  return {
    scope: 'CUSTOMER',
    type: 'GET',
    uri: `/customer/customers/`
  };
}

export function getConsolidatedOrderEndpoint(
  orderId: string
): IMetadataEndpoint {
  return {
    scope: 'ORDER',
    type: 'GET',
    uri: '/order/orders/' + orderId + '/consolidated'
  };
}

export function getDownloadOrderInvoiceEndpoint(
  orderId: string
): IMetadataEndpoint {
  return {
    scope: 'INVOICE',
    type: 'GET',
    uri: `/order-operations/invoice/order/${orderId}`
  };
}
